<template>
  <div class="app-container1">
    <div class="player-content" ref="playerContent" v-loading="loading"
          element-loading-text="设备正在加载中...">
      <!-- 顶部工具栏 -->
      <div class="top-toolbar">
     
        <div class="toolbar-group" >
          <div class="action-btn switch-action">
            <span>是否开启操作</span>
            <el-switch v-model="isClickBlocked" size="small" active-text="开启" inactive-text="关闭" />
          </div>
          <div v-if="isClickBlocked" style="display: flex;">
          <el-dropdown @command="handleClarityChange">
            <div class="action-btn">
              <el-icon><Monitor /></el-icon>
              <span>{{ currentClarityLabel }}</span>
              <el-icon class="action-arrow"><ArrowDown /></el-icon>
            </div>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item
                  v-for="item in resolutionList"
                  :key="item.value"
                  :command="item.value"
                  >{{ item.label }}</el-dropdown-item
                >
              </el-dropdown-menu>
            </template>
          </el-dropdown>
          <div class="action-btn" @click="switchDirection">
            <el-icon><Refresh /></el-icon>
            <span>旋转</span>
          </div>
          <div class="action-btn" @click="refreshStream">
            <el-icon><RefreshRight /></el-icon>
            <span>刷新</span>
          </div>
          <div class="action-btn" @click="restartDevice">
            <el-icon><SwitchButton /></el-icon>
            <span>重启</span>
          </div>
          <div class="action-btn" @click="toggleFullscreen">
            <el-icon><FullScreen /></el-icon>
            <span>{{ isFullscreen ? '退出全屏' : '全屏' }}</span>
          </div>
          <!-- 设备操作 -->
          <el-dropdown @command="handleDeviceCommand">
            <div class="action-btn">
              <el-icon><Setting /></el-icon>
              <span>设备操作</span>
              <el-icon class="action-arrow"><ArrowDown /></el-icon>
            </div>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item command="start">开机</el-dropdown-item>
                <el-dropdown-item command="reset">恢复出厂</el-dropdown-item>
                <el-dropdown-item command="quickNew">一键新机</el-dropdown-item>
                <el-dropdown-item command="screenRatio">设置分辨率</el-dropdown-item>
                <el-dropdown-item command="refreshCtrId">刷新CtrId</el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
          <!-- 更多工具 -->
          <el-dropdown @command="handleMoreCommand">
            <div class="action-btn">
              <el-icon><More /></el-icon>
              <span>更多</span>
              <el-icon class="action-arrow"><ArrowDown /></el-icon>
            </div>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item command="executeCommand">执行命令</el-dropdown-item>
                <el-dropdown-item command="limitSpeed">网络限速</el-dropdown-item>
                <el-dropdown-item command="adb">ADB</el-dropdown-item>
                <el-dropdown-item command="operateLog">操作日志</el-dropdown-item>
                <el-dropdown-item command="appBlackList">黑名单应用</el-dropdown-item>
                <el-dropdown-item command="appProxyWhiteList">应用代理白名单</el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
          </div>
        </div>
        <div class="toolbar-group">
          <div class="action-btn" @click="exitPage">
            <el-icon><Close /></el-icon>
            <span>退出</span>
          </div>
        </div>
      </div>
      <!-- 左右布局：左侧投屏，右侧已安装应用面板 -->
      <div class="main-area">
        <div class="left-area">
          <div class="video-container" :class="{ landscape: isLandscape }">
            <RemotePlayer
              class="flex-1 video-area"
              :video-angle="videoAngle"
              ref="webrtcScreen"
              :disabled="false"
              :cursor-type="1"
              :stream-angle="streamAngle"
              :is-key-mapping="isOpenKeyBoard"
              :cloudDeviceSize="cloudDeviceSize"
              @channelEvent="sendChannelEvent"
            />
            <!-- 透明遮罩层 -->
            <div v-if="!isClickBlocked" class="click-blocker">
            </div>
          </div>
          <div id="bottom-button" :style="{ cursor: !isClickBlocked ? 'not-allowed' : 'default' }">
            <div>
              <img
                src="@/assets/cloudPhone/ic_cast_screen_back.png"
                alt=""
                @click="chageCloudMachine(4)"
              />
            </div>
            <div>
              <img
                src="@/assets/cloudPhone/ic_cast_screen_home.png"
                alt=""
                @click="chageCloudMachine(3)"
              />
            </div>
            <div>
              <img
                src="@/assets/cloudPhone/ic_cast_screen_task.png"
                alt=""
                @click="chageCloudMachine(187)"
              />
            </div>
          </div>
        </div>
        <!-- 面板折叠开关 -->
        <div
          v-if="isClickBlocked"
          class="panel-toggle"
          :title="panelVisible ? '收起应用面板' : '展开应用面板'"
          @click="panelVisible = !panelVisible"
        >
          <el-icon>
            <ArrowRight v-if="panelVisible" />
            <ArrowLeft v-else />
          </el-icon>
        </div>
        <!-- 右侧：当前设备已安装应用 -->
        <deviceAppPanel v-show="panelVisible && isClickBlocked" :device-code="deviceCode" />
      </div>

      <!-- 错误异常处理UI -->
        <div v-if="webRTCError" class="error-container">
          <div class="error-content">
            <div class="error-message">{{ webRTCError?.message || '投屏连接失败' }}</div>
            <el-button v-show="webRTCError?.code !== -1" type="primary" size="large" @click="retryConnect" class="retry-button">
              重连
            </el-button>
          </div>
        </div>

        <!-- 设备操作后离线状态（开机/重启/恢复出厂/一键新机），提供重连入口 -->
        <div v-if="offlineMessage && !webRTCError" class="error-container">
          <div class="error-content">
            <el-icon class="offline-icon"><Loading /></el-icon>
            <div class="error-message">{{ offlineMessage }}</div>
            <el-button type="primary" size="large" @click="reconnectAfterOffline" class="retry-button">
              重新连接
            </el-button>
            <div class="offline-tip">设备尚未就绪时连接可能失败，可稍后再试</div>
          </div>
        </div>

      <!-- 设备操作相关弹窗（仅需设备编码） -->
      <setScreenRatio ref="setScreenRatioRef" />
      <executeCommand ref="executeCommandRef" />
      <limitSpeed ref="limitSpeedRef" />
      <ADBDetail ref="ADBDetailRef" />
      <appBlackList ref="appBlackListRef" />
      <appProxyWhiteList ref="appProxyWhiteListRef" />
      <deviceOperateLog ref="deviceOperateLogRef" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted, onUnmounted, provide } from "vue";
import {
  WebRTCSdk,
  ChannelDataType,
  EmitType,
  RemotePlayer,
  selectBestTurnServerFast,
  KeyEventData,
  InputData,
  ContainerDirection,
  ClarityData
} from "yjz-web-sdk";
import { useRoute } from "vue-router";
import { ElMessage } from "element-plus";
import comCueBox from "@/components/comCue/comCue";
import API_CONFIG from "../api.json";
import request from "@/utils/request.ts";
import setScreenRatio from "./setScreenRatio.vue";
import executeCommand from "./executeCommand.vue";
import limitSpeed from "./limitSpeed.vue";
import ADBDetail from "./ADBDetail.vue";
import appBlackList from "./appBlackList.vue";
import appProxyWhiteList from "./appProxyWhiteList.vue";
import deviceOperateLog from "./deviceOperateLog.vue";
import deviceAppPanel from "./deviceAppPanel.vue";
interface Dimension {
  width: number;
  height: number;
}

const route = useRoute();

// 本页面为独立全屏页，不经过 defaultTheme 布局；
// 布局在 defaultTheme.vue 中 provide 的 $tenantInfo 在这里缺失，
// 会导致弹窗内的表格组件(agTable/comTable/comList)在 getColumnDefs 时报
// "tenantCb is not a function"（操作日志、黑名单应用弹窗打不开）。
// 这里补齐 provide，独立页不是 root 用户视角，不展示租户列。
provide("$tenantInfo", () => ({ isRootUser: false }));

const screenStatus = ref(false);
const webrtcScreen = ref();
const sdk = ref<WebRTCSdk | null>(null);
const streamAngle = ref(0);
const cloudDeviceSize = ref<Dimension>({ width: 0, height: 0 });
const connectInfo = ref("");
let videoAngle = ref(0);
const gestureMode = ref(-1);
const loading = ref(false);
const screenWidth = ref(0);
const failReason = ref("");
const isOpenKeyBoard = ref(true);

// 添加遮罩层控制变量
const isClickBlocked = ref(false);

// 顶部工具栏
const playerContent = ref<HTMLElement>();
const isFullscreen = ref(false);
const clarityLevel = ref(2);
// 清晰度档位（与云端 clarityLevel 对应）
const resolutionList = [
  { label: "自动", value: 2 },
  { label: "超清", value: 4 },
  { label: "高清", value: 3 },
  { label: "普通", value: 1 },
];
const currentClarityLabel = computed(
  () =>
    resolutionList.find((ele) => ele.value === clarityLevel.value)?.label ||
    "自动"
);
// 横屏状态（点击旋转后），限制视频区域宽度
const isLandscape = computed(() => videoAngle.value === -90);

const statisticInfo = ref<{
  averageDecodeTime: number;
  bitrate: string;
  connectionType: string;
  currentRoundTripTime: number;
  framesDecoded: number;
  framesPerSecond: number;
  framesReceived: number;
  lostRate: number;
  pliCount: number;
}>();
const webRTCError = ref<{
  message: string;
  code: number;
}>();

const sendChannelEvent = (type: ChannelDataType, data: any) => {
  if (sdk.value) {
    if (data.keyCode === 50 && data.meta === 4096) {
      listenClip(type, data)
      return
    }
    sdk.value.sendChannelData(type, data);
  }
};

const chageCloudMachine = (data: number) => {
  if (!isClickBlocked.value) {
    return
  }
  if (sdk.value) {
    const keyEvent = new KeyEventData(data, 0);
    sdk.value.sendChannelData(ChannelDataType.ActionInput, keyEvent);
  }
};

const stopConnect = () => {
  screenStatus.value = false;
  if (sdk.value) {
    sdk.value.stop();
    sdk.value = null;
  }
  if (webrtcScreen.value) {
    webrtcScreen.value.stopPlay();
  }

  connectInfo.value = "";
};

// ===================== 设备操作后离线状态（重启/开机/恢复出厂/一键新机） =====================

// 离线提示文案，非空表示设备因上述操作断联，展示重连入口
const offlineMessage = ref("");

// 操作成功后断开投屏并切入离线状态
const enterOfflineState = (message: string) => {
  offlineMessage.value = message;
  stopConnect();
};

// 离线状态重连：走完整初始化流程（重新拉取连接配置）
const reconnectAfterOffline = () => {
  offlineMessage.value = "";
  refreshStream();
};

// ===================== 顶部工具栏 =====================

// 切换清晰度
const handleClarityChange = (level: number) => {
  if (level === clarityLevel.value) return;
  clarityLevel.value = level;
  sdk.value?.sendChannelData(
    ChannelDataType.ActionClarity,
    new ClarityData(level)
  );
};

// 旋转屏幕（纯前端视角旋转）
const switchDirection = () => {
  videoAngle.value = videoAngle.value === 0 ? -90 : 0;
};

// 刷新：断开并重连投屏流
const refreshStream = async () => {
  stopConnect();
  await init();
};

// 重启云机
const restartDevice = () => {
  comCueBox("重启设备需要几分钟时间，请确认是否重启").then(() => {
    request
      .post(API_CONFIG.reloadPhone.url, { deviceIds: [route.params.code] })
      .then((res: Record<string, any>) => {
        if (res.code == 200) {
          ElMessage.success("重启指令已下发");
          enterOfflineState("设备重启中，约需几分钟，请稍后重新连接");
        } else {
          ElMessage.error(res.msg);
        }
      })
      .catch((e: any) => {
        ElMessage.error("重启失败：" + e.message);
      });
  });
};

// 发送电脑剪贴板内容到云机
const sendClipboard = async () => {
  try {
    const content = await navigator.clipboard.readText();
    if (content) {
      sdk.value?.sendChannelData(
        ChannelDataType.ActionChinese,
        new InputData(content)
      );
      ElMessage.success("已发送剪贴板内容到云机");
    } else {
      ElMessage.warning("剪贴板内容为空");
    }
  } catch {
    ElMessage.error("读取剪贴板失败，请检查浏览器权限");
  }
};

// 全屏切换
const toggleFullscreen = () => {
  if (document.fullscreenElement) {
    document.exitFullscreen();
  } else {
    playerContent.value?.requestFullscreen();
  }
};
const onFullscreenChange = () => {
  isFullscreen.value = !!document.fullscreenElement;
};

// 退出：断开连接并关闭页面
const exitPage = () => {
  stopConnect();
  window.close();
  setTimeout(() => {
    if (!window.closed) {
      ElMessage.warning("连接已断开，请手动关闭本页面");
    }
  }, 500);
};

// ===================== 设备操作（同步设备管理/设备资源分配按钮） =====================

// 当前设备编码（路由参数）
const deviceCode = computed(() => route.params.code as string);
// 右侧应用面板折叠状态
const panelVisible = ref(true);

// 各操作弹窗引用
const setScreenRatioRef = ref();
const executeCommandRef = ref();
const limitSpeedRef = ref();
const ADBDetailRef = ref();
const appBlackListRef = ref();
const appProxyWhiteListRef = ref();
const deviceOperateLogRef = ref();

// 开机（批量重载设备）
const startDevice = () => {
  comCueBox(`确认设备${deviceCode.value}是否开机`).then(() => {
    request
      .post(API_CONFIG.batchStartDevice.url, {
        ctrAliaList: [deviceCode.value],
      })
      .then((res: Record<string, any>) => {
        if (res.code == 0) {
          ElMessage.success("开机指令已下发");
          enterOfflineState("设备开机中，约需几分钟，请稍后重新连接");
        } else {
          ElMessage.error(res.msg);
        }
      })
      .catch((e: any) => {
        ElMessage.error("开机失败：" + e.message);
      });
  });
};

// 恢复出厂
const resetDevice = () => {
  comCueBox(
    "恢复出厂设置会清掉设备数据，且需要几分钟的时间，确认是否恢复出厂设置"
  ).then(() => {
    request
      .post(API_CONFIG.resetPhone.url, { deviceIds: [deviceCode.value] })
      .then((res: Record<string, any>) => {
        if (res.code == 200) {
          ElMessage.success("恢复出厂指令已下发");
          enterOfflineState("设备恢复出厂中，约需几分钟，请稍后重新连接");
        } else {
          ElMessage.error(res.msg);
        }
      })
      .catch((e: any) => {
        ElMessage.error("恢复出厂失败：" + e.message);
      });
  });
};

// 一键新机
const quickNewDevice = () => {
  comCueBox("确认是否对该设备执行一键新机操作？").then(() => {
    request
      .post(API_CONFIG.quickNewDevice.url, {
        deviceIds: [deviceCode.value],
        modelId: "111",
      })
      .then((res: Record<string, any>) => {
        if (res.code == 200) {
          ElMessage.success("一键新机指令已下发");
          enterOfflineState("设备一键新机处理中，约需几分钟，请稍后重新连接");
        } else {
          ElMessage.error(res.msg);
        }
      })
      .catch((e: any) => {
        ElMessage.error("一键新机失败：" + e.message);
      });
  });
};

// 刷新CtrId
const refreshCtrId = () => {
  request
    .post(API_CONFIG.refreshCtrIdUrl.url, {
      cloudMachineNumbers: [deviceCode.value],
    })
    .then((res: Record<string, any>) => {
      if (res.code == 200) {
        ElMessage.success("刷新CtrId成功");
      } else {
        ElMessage.error(res.msg || "刷新CtrId失败");
      }
    })
    .catch((e: any) => {
      ElMessage.error("刷新CtrId失败：" + e.message);
    });
};

// 设备操作下拉
const handleDeviceCommand = (command: string) => {
  switch (command) {
    case "start":
      startDevice();
      break;
    case "reset":
      resetDevice();
      break;
    case "quickNew":
      quickNewDevice();
      break;
    case "screenRatio":
      setScreenRatioRef.value?.open([deviceCode.value]);
      break;
    case "refreshCtrId":
      refreshCtrId();
      break;
  }
};

// 更多下拉（弹窗内实际仅使用设备编码）
const handleMoreCommand = (command: string) => {
  const row = { code: deviceCode.value, name: deviceCode.value, id: "" };
  switch (command) {
    case "executeCommand":
      executeCommandRef.value?.open(row);
      break;
    case "limitSpeed":
      limitSpeedRef.value?.open([row]);
      break;
    case "adb":
      ADBDetailRef.value?.open(row);
      break;
    case "operateLog":
      deviceOperateLogRef.value?.open(deviceCode.value);
      break;
    case "appBlackList":
      appBlackListRef.value?.open(row);
      break;
    case "appProxyWhiteList":
      appProxyWhiteListRef.value?.open(row);
      break;
  }
};

const handleCloudSize = (cloudStatus: any) => {
  cloudDeviceSize.value = {
    width: cloudStatus.screenWidth,
    height: cloudStatus.screenHeight,
  };
};

const handleCloudGestureMode = (cloudStatus: any) => {
  gestureMode.value = cloudStatus.gestureMode;
};

const initRemotePlayer = (config) => {
  sdk.value = new WebRTCSdk({
    ...config,
    isGroup: false,
  });

  if(!config.roomId){
    webRTCError.value = {
      message: '云机损坏，请关闭当前页面重进或者咨询下技术人员',
      code: -1,
    }
    loading.value = false;
    return
  }
  if (sdk.value) {
    screenWidth.value =
      webrtcScreen.value?.remoteVideoElement?.clientWidth || 300;
    const bottomDom = document.getElementById("bottom-button");
    if (bottomDom) {
      bottomDom.style.width = screenWidth.value + "px";
    }
    sdk.value.startConnection();

    sdk.value.on(EmitType.streamTrack, (track: MediaStreamTrack) => {
      if (webrtcScreen.value) {
        webrtcScreen.value.startPlay(track);
      }
    });

    sdk.value.on(EmitType.iceConnectionState, (state: string) => {
      console.info("iceConnectionState", state);
      if (state === "connected") {
        loading.value = false;
        webRTCError.value = undefined;
      }
    });

    sdk.value.on(EmitType.cloudStatusChanged, (cloudStatus: any) => {
      streamAngle.value = cloudStatus.direction === ContainerDirection.Vertical ? 0 : -90
      console.info("cloudStatusChanged", cloudStatus);
      handleCloudSize(cloudStatus);
      handleCloudGestureMode(cloudStatus);
      // 云端回推当前清晰度，同步下拉回显
      if (cloudStatus.clarityLevel !== undefined) {
        clarityLevel.value = cloudStatus.clarityLevel;
      }
    });

    sdk.value.on(EmitType.webrtcError, (error: any) => {
      if (
        error.code !== 10011 &&
        error.code !== 10013 &&
        error.code !== 10014 &&
        error.code !== 10015
      ) {
         if (!failReason.value || failReason.value.length === 0) {
          if (error.code === 10001) {
            failReason.value = '信令服务连接失败'
          } else if (error.code === 10002) {
            failReason.value = '信令服务已关闭'
          } else if (error.code === 10012) {
            failReason.value = '云机已关机或者不存在'
          } else if (error.code === 10016) {
            failReason.value = '投屏连接失败，同一云机最多支持打开3个投屏，请检查确认关闭其他投屏再重连'
          } else {
            failReason.value = '投屏服务连接失败'
          }
        }
        webRTCError.value = {
          code: error.code,
          message:  failReason.value|| error.message
        }
        stopConnect();
      }
    });

    sdk.value.on(EmitType.statisticInfo, (info: any) => {
      console.info("statisticInfo", info);
      statisticInfo.value = info;
    });

    sdk.value.on(EmitType.cloudClipData, (message: string) => {
      console.info("cloudClipData", message);
    });
  }
};

const getBestTurn = async (turnList: string[]) => {
  try {
    const { best } = await selectBestTurnServerFast(turnList);
    return best?.urls;
  } catch {
    return undefined;
  }
};

const getTurnUri = async (data): Promise<string> => {
  return (
    (await getBestTurn(data.hostTurn)) ||
    (await getBestTurn(data.spareTurn)) ||
    data.turnServerUri
  );
};

const getConnectConfig = (data) => {
  return request.get(API_CONFIG.connectConfig.url + `?ctrAlias=${data.code}`);
};

const phoneInfo = ref({})
const init = async () => {
  try {
    // searchUserDevice();
    loading.value = true;
    webRTCError.value = null
    offlineMessage.value = "";
    const res: any = await getConnectConfig({code: route.params.code});
    if (res.data) {
      phoneInfo.value = res.data
      const bestTurnURL = await getTurnUri(res.data);
      initRemotePlayer({
        ...res.data,
        turnServerUri: bestTurnURL,
        turnKey: [bestTurnURL],
      });
    } else {
      loading.value = false;
      webRTCError.value = {
        message: "获取投屏配置异常,请关闭当前页面重进或者联系技术人员",
        code: -1,
      };
    }
  } catch (error) {
    const errMsg = `${error.message || ""}`;
    // 可重试的连接异常：云机非运行状态（关机/开机/重启中）、云机不存在（重建/换机中）
    // 切入离线状态并提供重连入口（走完整重新初始化），而非致命错误
    if (errMsg.includes("非运行") || errMsg.includes("云机不存在")) {
      loading.value = false;
      offlineMessage.value = errMsg.includes("非运行")
        ? "云机非运行状态，设备可能正在开机/重启中，请稍后重新连接"
        : "云机不存在，设备可能正在重建/换机中，请稍后重新连接";
      return;
    }
    webRTCError.value = {
      message: `${error.message},请关闭当前页面重进或者联系技术人员`,
      code: -1,
    };
    loading.value = false;
  }
};

// 重试连接方法
const retryConnect = async() => {
    webRTCError.value = null
    offlineMessage.value = ""
    loading.value = true
        const bestTurnURL = await getTurnUri(phoneInfo.value);
      initRemotePlayer({
        ...phoneInfo.value,
        turnServerUri: bestTurnURL,
        turnKey: [bestTurnURL],
      });
}

const listenClip = async (type: ChannelDataType, data:any) => {
  const currentClipboardContent = await navigator.clipboard.readText() // 获取当前剪切板内容
  if (currentClipboardContent) {
    if(sdk.value) {
      sdk.value.sendChannelData(ChannelDataType.ActionChinese, new InputData(currentClipboardContent))
    }
  } else {
      sdk.value?.sendChannelData(type, data);
  }
}

// 监听开关变化，当开启时重新加载云机
// watch(isClickBlocked, async (newValue, oldValue) => {
//   if (!newValue && oldValue) {
//     // 开关从关闭变为开启，重新加载云机
//     stopConnect();
//     await init();
//   }
// });

onMounted(() => {
  document.addEventListener("fullscreenchange", onFullscreenChange);
  init();
});

onUnmounted(() => {
  document.removeEventListener("fullscreenchange", onFullscreenChange);
  stopConnect();
});
</script>
<style scoped lang="scss">
.app-container1 {
  position: relative;
  background: #000;
  min-height: 100vh;
  width: 100vw;
}
/* 顶部工具栏 */
.top-toolbar {
  width: 100%;
  height: 48px;
  flex-shrink: 0;
  box-sizing: border-box;
  background: rgba(0, 0, 0, 0.85);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  z-index: 12;
}
.toolbar-group {
  display: flex;
  align-items: center;
  gap: 4px;
}
.action-btn {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 6px 10px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 13px;
  color: #fff;
  outline: none;
  transition: all 0.2s;
  &:hover {
    background: rgba(255, 255, 255, 0.15);
  }
}
.action-arrow {
  font-size: 12px;
}
.player-content {
  height: 100vh;
  display: flex;
  flex-direction: column;
}
.flex-1 {
  flex: 1 1 0%;
}

/* 左右布局主区域 */
.main-area {
  flex: 1;
  min-height: 0;
  width: 100%;
  display: flex;
}

.left-area {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.video-area {
  position: relative;
}

/* 视频容器 */
.video-container {
  position: relative;
  width: 100%;
  height: 100%;
  flex: 1;
  /* 旋转重算尺寸的瞬间 vContainer 可能短暂超出容器高度，
     必须禁止 flex item 被内容撑大（min-height:auto），
     否则撑大的尺寸会被 SDK 的 ResizeObserver 上报回去，
     导致页面高度被永久撑高（转回去也恢复不了） */
  overflow: hidden;
  min-height: 0;
}

/* 旋转横屏时限制视频区域宽度 */
.video-container.landscape {
  width: 50%;
  min-width: 500px;
}

/* 面板折叠开关窄条 */
.panel-toggle {
  width: 20px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #999;
  background: rgba(0, 0, 0, 0.6);
  border-left: 1px solid #333;
  transition: all 0.2s;
  &:hover {
    color: #fff;
    background: rgba(255, 255, 255, 0.12);
  }
}

/* 透明遮罩层 */
.click-blocker {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: transparent;
  z-index: 10;
  cursor: not-allowed;
}

#bottom-button {
  color: white;
  height: 60px;
  min-width: 400px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  > div {
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 25px;
    }
  }
}

.error-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 1);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 15;
}

.error-content {
  text-align: center;
  color: white;
  padding: 40px;
  border-radius: 8px;
}

.error-icon {
  font-size: 64px;
  color: #f56c6c;
  margin-bottom: 20px;
}

.error-message {
  font-size: 18px;
  margin-bottom: 30px;
  line-height: 1.5;
}

.retry-button {
  font-size: 16px;
  padding: 10px 30px;
}

/* 设备操作后离线状态 */
.offline-icon {
  font-size: 42px;
  color: #e6a23c;
  margin-bottom: 16px;
  animation: offline-rotating 2s linear infinite;
}

@keyframes offline-rotating {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.offline-tip {
  margin-top: 14px;
  font-size: 13px;
  color: #999;
}
</style>
